
/* ==========================================================================

  Front end only

  Author:     Stephen Zsolnai (http://www.zolla.co.uk)
  Decription: A testbed for functionality to test against dev-templates.
              This can be used when testing needs to be more visual and actual tests will be too complex.
              For instance, localisation and pluralisation in Handlebars templates.
              We need a visual representation in one place for the many variants accross cultures.

              THIS FILE WILL BE EXCLUDED IN THE DIST GRUNT TASK
========================================================================== */

'use strict';

var $ = require('jquery'),
  $localisationWrapper = $('.js-hbsLocalisationTestWrapper');

/* Localisation Handlebars tesbed
========================================================================== */
if ($localisationWrapper.length) {
  var LocalisationTests = require('./localisationTests');
  new LocalisationTests({
    el: '.js-hbsLocalisationTestWrapper'
  });
}



// WEBPACK FOOTER //
// ./assets/js/frontend-only/feIndex.js